import React from "react";
import { isMobileOnly } from "react-device-detect";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { siteUrl } from "../../utils/constants";
import type { StrapiMedia, StrapiBlock } from "../../types/strapi";
import { mediaUrl } from "../../utils/imageUtils";

interface BackgroundSectionProps {
  image?: StrapiMedia | null;
  heading?: string;
  textBlock?: StrapiBlock[];
}

const BackgroundSection: React.FC<BackgroundSectionProps> = ({
  image,
  heading,
  textBlock,
}) => {
  const imageUrl = isMobileOnly
    ? image?.formats?.medium?.url ?? image?.url
    : image?.url;

  return (
    <div
      className="rn-finding-us-area attacment-fixed rn-finding-us ptb--120 bg_color--1 bg_image"
      data-black-overlay="5"
      style={{
        backgroundImage: imageUrl ? `url(${mediaUrl(imageUrl)})` : undefined,
        backgroundAttachment: isMobileOnly ? "scroll" : "fixed",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="inner">
              <div className="content-wrapper">
                <div className="content">
                  {heading && <h3 className="theme-gradient">{heading}</h3>}
                  {textBlock && <BlocksRenderer content={textBlock} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackgroundSection;
